import {merge} from '#core/utils/config-utils.js';
import {resolveBackground} from '#core/utils/color-utils.js';
import {icon} from '#core/utils/style-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import {generateSimplePopover} from '#core/application/modules/tiles/popover/index.js';
import {generateTertiaryLink} from '#core/application/modules/tiles/link/index.js';

import BONUS_INDICATOR from './bonus-indicator.palette-schema.yaml';
import EARLY_PAYOUT_INDICATOR from './early-payout-indicator.palette-schema.yaml';

registerTileSchema(BONUS_INDICATOR);
registerTileSchema(EARLY_PAYOUT_INDICATOR);

export function generateBonusIndicator(TILE) {
    return {
        labeledTooltip: {
            disableTooltip: TILE.BONUS_INDICATOR_POPOVER_HIDDEN,
            clickableArea: {
                style: {
                    base: {
                        minHeight: 'initial',
                    },
                },
            },
            labelContainer: {
                style: {
                    ...resolveBackground(TILE.BONUS_INDICATOR_BG),
                    borderWidth: 1,
                    borderStyle: 'solid',
                    borderColor: TILE.BONUS_INDICATOR_BORDER_COLOR,
                    borderRadius: TILE.BONUS_INDICATOR_BORDER_RADIUS,
                    overflow: 'hidden',
                },
            },
            icon: merge(icon(TILE.BONUS_INDICATOR_ICON_COLOR), {
                style: {
                    minWidth: TILE.BONUS_INDICATOR_ICON_WIDTH,
                    minHeight: TILE.BONUS_INDICATOR_ICON_HEIGHT,
                    height: TILE.BONUS_INDICATOR_ICON_HEIGHT,
                    width: TILE.BONUS_INDICATOR_ICON_WIDTH,
                },
            }),
            title: {
                truncate: true,
                style: {
                    padding: '0 2px 0 0', // we need this because when the text is truncated, italic characters are partially cut off
                    ...TILE.BONUS_INDICATOR_TEXT,
                },
            },
            // awarded
            additionalInfo: {
                container: {
                    padding: '0 4px 0 5px',
                    clipPath:
                        'polygon(3px 0, calc(100% + 1px) 0, calc(100% + 1px) calc(100% + 1px), 0 calc(100% + 1px))',
                    ...resolveBackground(TILE.BONUS_INDICATOR_AWARDED_BG),
                },
                style: {
                    ...TILE.BONUS_INDICATOR_AWARDED_TEXT,
                },
            },
            tooltip: {
                popup: generateSimplePopover(
                    TILE.BONUS_INDICATOR_POPOVER_BG,
                    TILE.BONUS_INDICATOR_POPOVER_BORDER_RADIUS,
                    TILE.BONUS_INDICATOR_POPOVER_SHADOW,
                    TILE.BONUS_INDICATOR_POPOVER_BORDER_COLOR
                ),
                textLabel: {
                    container: {
                        paddingTop: '10px',
                    },
                    style: {
                        ...TILE.BONUS_INDICATOR_POPOVER_TEXT,
                    },
                },
                linkButton: merge(generateTertiaryLink(TILE.BONUS_INDICATOR_POPOVER_LINK), {
                    style: {
                        base: {
                            width: 'fit-content',
                            paddingTop: '10px',
                        },
                    },
                }),
                closeButton: {
                    buttonIcon: {
                        style: {
                            fill: TILE.BONUS_INDICATOR_POPOVER_CLOSE_BUTTON_ICON_COLOR,
                        },
                    },
                },
            },
        },
    };
}

export function generateEarlyPayoutIndicator(TILE) {
    return generateBonusIndicator(TILE.EARLY_PAYOUT_BONUS_INDICATOR);
}
